import { Button, HorizontalMenu, Icons } from "@win-reality/react-ui";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useNavMenu } from "@/components/ui/SideMenu";
import { ROUTES } from "@/lib/routes";

const tabs = [
  { label: "Admins", to: ROUTES.ADMIN_TOOLS_ADMINS },
  {
    label: "Account Verifications",
    to: ROUTES.ADMIN_TOOLS_ACCOUNT_VERIFICATION,
  },
  { label: "Find CSV", to: ROUTES.ADMIN_TOOLS_FIND_CSV },
];

const AdminToolsLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isOpen, setIsOpen } = useNavMenu();

  return (
    <div className="flex flex-col h-full">
      <div className="p-5 flex justify-between">
        <div>
          <div className="shrink-0 md:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setIsOpen(!isOpen)}
            >
              <Icons.Bars3BottomLeftOutline />
              <span className="sr-only">Toggle Menu</span>
            </Button>
          </div>
        </div>
      </div>

      <div className="md:pt-0 px-5">
        <div className="border border-b-gray-200 grow flex justify-center min-w-0">
          <HorizontalMenu
            size="md"
            wrapperClassName="w-full [&>*]:mx-auto"
            items={tabs.map((tab) => ({
              label: tab.label,
              active: location.pathname.startsWith(tab.to),
              onClick: () => navigate(tab.to),
            }))}
          />
        </div>
      </div>
      <div className="flex-1 py-8">
        <Outlet />
      </div>
    </div>
  );
};

export { AdminToolsLayout };
